var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.headers
        ? _c("Toolbar", {
            style: {
              borderLeft: _vm.type === "notepad" ? "" : "1px solid #dcdfe6ff",
            },
            attrs: {
              defaultConfig: _vm.toolbarConfig,
              editor: _vm.editor,
              mode: _vm.mode,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main", style: { "--width": _vm.mainWidth } },
        [
          _c("Editor", {
            ref: "wang-editor",
            style: {
              "--height": _vm.height,
              border: _vm.editorBorder ? "1px solid #dcdfe6ff" : "none",
            },
            attrs: { defaultConfig: _vm.editorConfig, mode: _vm.mode },
            on: { onChange: _vm.onChange, onCreated: _vm.onCreated },
            model: {
              value: _vm.contentVal,
              callback: function ($$v) {
                _vm.contentVal = $$v
              },
              expression: "contentVal",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }